import { render } from "./CreateCoin.vue?vue&type=template&id=dfcc6346&scoped=true"
import script from "./CreateCoin.vue?vue&type=script&lang=js"
export * from "./CreateCoin.vue?vue&type=script&lang=js"

import "./CreateCoin.vue?vue&type=style&index=0&id=dfcc6346&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../../Users/jamarrucho/Documents/2024/04_Unit/Dev/unit-org_2025_10_24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfcc6346"]])

export default __exports__